<template>
	<LayoutBase>
		<header id="content__header">
			<h1>{{ resource.name }}</h1>
            <button
                @click="showDeleteModal()"
                class="btn btn--danger"
                v-if="resource.can.delete"
                v-wait:disabled="['saving preview resource', 'deleting preview resource']"
            >
                Delete
            </button>
			<router-link
                :to="{ name: 'preview-document', params: { insight_id: resource.id }}"
                class="btn btn--primary"
                v-if="resource.can.edit"
            >
                Edit
			</router-link>
		</header>
		<ul class="grid post-details">
			<li v-if="resource.createdAt" class="col-6 col-md-3 detail">
				<span class="label">Posted</span>
				<span class="h3"><SvgIcon :icon="'calendar'" /> {{ resource.createdAt }}</span>
			</li>
			<li v-if="resource.sectors" class="col-6 col-md-9 detail">
				<span class="label">Sectors</span>
				<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
			</li>
			<li v-if="resource.category" class="col-6 col-md-3 detail">
				<span class="label">Category</span>
				<span class="h3"><SvgIcon :icon="'category'" /> {{ resource.category.name }}</span>
			</li>
			<li v-if="resource.type" class="col-6 col-md-3 detail">
				<span class="label">Content Type</span>
				<span class="h3">{{ resource.type }}</span>
			</li>
		</ul>
		<section class="grid">
			<div class="col-12 col-md-8">
				<div class="card" v-if="resource.description">
					<div class="header">Description</div>
					<div v-html="resource.description"></div>
				</div>
				<div class="card" v-if="resource.attachments && resource.attachments.length">
					<div class="header">Attachments</div>
					<ul class="documents" v-if="resource.attachments && resource.attachments.length > 0">
						<li v-for="doc in resource.attachments">
							<AttachmentDownload :attachment="doc" />
						</li>
					</ul>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div v-if="resource.member" class="card card--image">
					<img :src="`/images/logo/${resource.member.id}`" />
				</div>
				<div v-if="resource.creator" class="profile-list">
					<p class="profile-list__title">Creator</p>
					<UserCard :user="resource.creator" :borderless="true"></UserCard>
				</div>
			</div>
		</section>
	</LayoutBase>
</template>
<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import ResourceView from '../ResourceView';
	import UserCard from '../User/UserCard';
    import AttachmentDownload from '../AttachmentDownload';

	export default {
		name: 'InsightView',
		mixins: [ResourceView],
		components: {
            AttachmentDownload,
			UserCard,
			LayoutBase,
			SvgIcon,
		},
        data() {
            return {
                deleteModal: {
                    title: 'Are you sure you want to delete this Insight?',
                    buttonLabel: 'Delete Insight',
                },
            };
        },
        watch: {
            id: function (newVal, oldVal) {
                return API.getInsight(newVal).then(response => {
                    console.log("[InsightView.vue] - ", response);
                    this.resource = response;
                });
            }
        },
		methods: {
			fetchResource() {
				return API.getInsight(this.id);
			},
            deleteResource() {
                return API.deleteInsight(this.id)
                    .then(() => {
                        this.$router.push({ name: 'documents' });
                    });
            },
            showDeleteModal() {
                this.$modal.show('dialog', {
                    title: this.deleteModal.title,
                    text: this.deleteModal.content,
                    buttons: [
                        {
                            class: 'btn btn--danger',
                            title: this.deleteModal.buttonLabel,
                            handler: () => {
                                this.deleteResource();
                            }
                        },
                    ]
                });
            },
		},
	}
</script>

<style lang="scss" scoped>
	.card + .card {
		margin-top: 2rem;
	}

	.post-details{
		margin: 2rem 0;
	}
</style>
